<pre><code class="language-xml" [innerHTML]="highlightedXml" ></code></pre>
